import { createStore } from "vuex";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import axios from "axios";

export default createStore({
  state: {
    apiUrl: "https://clic.akxatech.com/api/",
    // apiUrl: "http://localhost/clic/laravel/public/api/",
    // Dev: /api/ → vue.config.js proxy. Prod: .env.production (XAMPP public path).
    // apiUrl: process.env.VUE_APP_API_URL || "/api/",
    authenticated: false,
    user: null,
    token: "",
    status: "",
    page: "",
    permissions: [],
    email: "",
    download_status: false,
  },
  mutations: {
    setDownloadStatus(state, download_status) {
      state.download_status = download_status;
    },
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setPage(state, page) {
      state.page = page;
    },
    setUrl(state, url) {
      state.apiUrl = url;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
  },
  getters: {
    download_status(state) {
      return state.download_status;
    },
    user(state) {
      return state.user;
    },
    status(state) {
      return state.status;
    },
    page(state) {
      return state.page;
    },
    token(state) {
      return state.token;
    },
    apiUrl(state) {
      return state.apiUrl;
    },
    permissions(state) {
      return state.permissions;
    },
    email(state) {
      return state.email;
    },
  },

  actions: {
    async setDownloadStatus(context, payload) {
      await context.commit("setDownloadStatus", payload);
    },
    async setUser(context, payload) {
      await context.commit("setUser", payload);
    },
    async setStatus(context, payload) {
      await context.commit("setStatus", payload);
    },
    async setPage(context, payload) {
      await context.commit("setPage", payload);
    },
    async setToken(context, payload) {
      // sessionStorage.setItem("token", payload)
      await context.commit("setToken", payload);
    },
    async setPermissions(context, payload) {
      await context.commit("setPermissions", payload);
    },
    async setEmail(context, payload) {
      await context.commit("setEmail", payload);
    },
    async logout(context) {
      // sessionStorage.removeItem('user');
      // sessionStorage.removeItem('token');
      await context.commit("setUser", null);
      await context.commit("setToken", "");
      await context.commit("setPermissions", null);
    },
    auth(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(context.state.apiUrl + payload.uri, payload.data, {
            headers: { Accept: "application/json" },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    get(context, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get(context.state.apiUrl + payload.uri, {
            params: payload.data,
            headers: { Authorization: "Bearer" + " " + context.getters.token },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },

    post(context, payload) {
      // console.log("token",context.getters.token)
      return new Promise((resolve, reject) => {
        axios
          .post(context.state.apiUrl + payload.uri, payload.data, {
            headers: {
              Accept: "application/json",
              Authorization: "Bearer" + " " + context.getters.token,
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
            if (error.response.data.message == "Unauthenticated.") {
              context.dispatch("logout");
              window.location.href = "/#/";
              window.location.reload();
            }
          });
      });
    },

    async error(context, description) {
      await createToast(
        {
          title: "Error",
          description: description || "The given data was invalid.",
        },
        {
          showIcon: true,
          hideProgressBar: true,
          type: "danger",
          position: "top-right",
        },
      );
    },

    async success(context, description) {
      await createToast(
        {
          title: "Success",
          description: description || "Data is successfully submitted.",
        },
        {
          showIcon: true,
          hideProgressBar: true,
          type: "success",
          position: "top-right",
        },
      );
    },

    async info(context, description) {
      await createToast(
        {
          title: "Info",
          description: description || "Not enoguh input data",
        },
        {
          showIcon: true,
          hideProgressBar: true,
          type: "info",
          position: "top-right",
        },
      );
    },
  },
  modules: {},
});
